/* Independent custom elements also initialize when Shopify replaces a section. */
(() => {
  if (!customElements.get('skil-carousel')) {
    customElements.define('skil-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.paused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.select(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.select(this.index + 1), options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i), options));
        this.querySelector('[data-pause]')?.addEventListener('click', () => {
          this.paused = !this.paused;
          const button = this.querySelector('[data-pause]');
          button.setAttribute('aria-pressed', String(this.paused));
          button.textContent = this.paused ? '▶' : 'Ⅱ';
          button.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => this.stop(), options);
        this.addEventListener('mouseleave', () => this.schedule(), options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', () => this.schedule(), options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          const delta = event.changedTouches[0].clientX - this.touchX;
          if (Math.abs(delta) > 60) this.select(this.index + (delta < 0 ? 1 : -1));
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (i >= 0) { this.select(i); this.stop(); }
        }, options);
        this.select(0);
      }
      select(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
        this.schedule();
      }
      stop() { clearTimeout(this.timer); }
      schedule() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.paused || this.motion.matches || document.hidden || this.matches(':hover') || this.contains(document.activeElement) || window.Shopify?.designMode || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.select(this.index + 1), Number(this.dataset.interval || 6) * 1000);
      }
      disconnectedCallback() { this.stop(); this.abort?.abort(); this.abort = null; }
    });
  }
  if (!customElements.get('skil-benefits')) {
    customElements.define('skil-benefits', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const items = [...this.querySelectorAll('details')];
        const images = [...this.querySelectorAll('[data-benefit-image]')];
        const activate = index => {
          items.forEach((item, i) => { item.open = i === index; });
          images.forEach((image, i) => { image.hidden = i !== index; });
        };
        items.forEach((item, i) => item.querySelector('summary').addEventListener('click', event => {
          event.preventDefault(); activate(i);
        }, { signal: this.abort.signal }));
        document.addEventListener('shopify:block:select', event => {
          const i = items.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (i >= 0) activate(i);
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('skil-rail')) {
    customElements.define('skil-rail', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const track = this.querySelector('[data-track]');
        this.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
          const first = track.firstElementChild;
          const step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
          track.scrollBy({ left: Number(button.dataset.scroll) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.abort.signal }));
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
})();
